import $$ from 'cmn-utils'
import { SaveFile } from "@/utils/tool";


const baseUrl = "/api/datav/datascreen/echarts/";
export default {
    exportExcel: (data) => {
        SaveFile(`api/datav/datascreen/echarts/export-excel`, data);
        return true
    },
    countWorkOrderDoubler: (params) => {
        return $$.get(baseUrl + 'count-work-order/doubler', params)
    },
    countWorkOrderStatePie: (params) => {
        return $$.get(baseUrl + 'count-work-order-state/pie', params)
    },

    countWorkOrderTypePie: (params) => {
        return $$.get(baseUrl + 'count-work-order-type/pie', params)
    },
    countWorkOrderHandleMethodPie: (params) => {
        return $$.get(baseUrl + 'count-work-order-handle-method/pie', params)
    },

    countAlarmDoubler: (params) => {
        return $$.get(baseUrl + 'count-alarm/doubler', params)
    },
    countAlarmStatePie: (params) => {
        return $$.get(baseUrl + 'count-alarm-state/pie', params)
    },

    // 工单增长趋势
    workOrderIncreasingTendencyLine: (params) => {
        return $$.get(baseUrl + 'work-order-increasing-tendency/line', params)
    },
    //告警增长趋势
    alarmIncreasingTendencyLine: (params) => {
        if (params.startTime) {
            params.startTime = params.startTime.format("YYYY-MM-DD HH:mm:ss");
        }
        if (params.endTime) {
            params.endTime = params.endTime.format("YYYY-MM-DD HH:mm:ss");
        }
        return $$.get(baseUrl + 'alarm-increasing-tendency/line', params)
    },

    //地图
    countDeviceMapMigrate: (params) => {
        return $$.get(baseUrl + 'count-device/map-migrate', params)
    },
    countDeviceStatePie: (params) => {
        return $$.get(baseUrl + 'count-device-state/pie', params)
    },
    countDeviceStateDoubler: (params) => {
        return $$.get(baseUrl + 'count-device-state/doubler', params)
    },

    // 设备统计
    countDevicePie: (params) => {
        return $$.get(baseUrl + 'count-device/pie', params)
    },
    deviceIncreasingTendencyLine: (params) => {
        return $$.get(baseUrl + 'device-increasing-tendency/line', params)
    },


    newAlarmList: (params) => {
        return $$.get(baseUrl + 'new-alarm-list', params)
    },
    newWorkOrderList: (params) => {
        return $$.get(baseUrl + 'new-work-order-list', params)
    },
    countUnitCategoryPie: (params) => {
        return $$.get(baseUrl + 'count-unit-category/pie', params)
    },
    countUnitAlarmList: (params) => {
        return $$.get(baseUrl + 'count-unit-alarm-list', params)
    },
    countDeviceGroupbyAreaUnitProductBar: (params) => {
        return $$.get(baseUrl + 'count-device-groupby-area-unit-product/bar', params)
    },
    countDeviceMap: (params) => {
        return $$.get(baseUrl + 'count-device/map', params)
    },
}